import { computed, defineComponent, ref } from 'vue';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { EmergencyGetter } from '@/store/emergency/emergency.module';
import { Emergency } from '@/store/emergency/emergency.model';
import { AccountGetter } from '@/store/account/account.module';
import { Role } from '@/store/role/role.model';
import EmergencyFormComponent from '@/components/emergencyTable/emergencyForm/EmergencyForm.vue';
import EmergencyAttachmentOffcanvasComponent from '@/components/emergencyDetail/emergencyAttachmentOffcanvas/EmergencyAttachmentOffcanvas.vue';
import EmergencyAttachmentModalComponent from '@/components/emergencyDetail/emergencyAttachmentModal/EmergencyAttachmentModal.vue';
import EmergencyAttachmentFormComponent from '@/components/emergencyDetail/emergencyAttachmentForm/EmergencyAttachmentForm.vue';
import EmergencyImageModalComponent from '@/components/emergencyDetail/emergencyImageModal/EmergencyImageModal.vue';
import EmergencyAnswerComponent from '@/components/emergencyAnswer/EmergencyAnswer.vue';

export default defineComponent({
  name: 'EmergencyDetailComponent',
  components: {
    EmergencyFormComponent,
    EmergencyAttachmentOffcanvasComponent,
    EmergencyAttachmentModalComponent,
    EmergencyAttachmentFormComponent,
    EmergencyImageModalComponent,
    EmergencyAnswerComponent,
  },
  props: {
    emergencyId: {
      type: Number,
    }
  },
  setup: (props) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const emergency = computed<Emergency | undefined>(() => store.getters[EmergencyGetter.BY_ID](props.emergencyId));
    const isLoading = computed(() => store.getters[EmergencyGetter.STATUS] === 'init' ||  store.getters[EmergencyGetter.STATUS] === 'loading');
    const role = computed<Role | undefined>(() => store.getters[AccountGetter.SINGLE_ROLE]);
    const isOrs = computed(() => role.value?.name === 'เจ้าหน้าที่ ส.กกภ.');
    const isProvince = computed(() => role.value?.name === 'เจ้าหน้าที่ประจำจังหวัด');
    const emergencyForm = ref<InstanceType<typeof EmergencyFormComponent>>();
    const emergencyAttachmentOffcanvas = ref<InstanceType<typeof EmergencyAttachmentOffcanvasComponent>>();
    const emergencyAttachmentModel = ref<InstanceType<typeof EmergencyAttachmentModalComponent>>();
    const emergencyAttachmentForm = ref<InstanceType<typeof EmergencyAttachmentFormComponent>>();
    const emergencyImageModal = ref<InstanceType<typeof EmergencyImageModalComponent>>();

    const editClick = () => {
      emergencyForm.value?.show();
    };

    const attachmentClick = () => {
      emergencyAttachmentModel.value?.show();
    };

    const uploadClick = () => {
      Promise.resolve(emergencyAttachmentModel.value?.hide())
        .then(() => emergencyAttachmentForm.value?.show());
    };

    const uploadClose = () => {
      Promise.resolve(emergencyAttachmentForm.value?.hide())
        .then(() => emergencyAttachmentModel.value?.show());
    };

    const imageClick = () => {
      emergencyImageModal.value?.show();
    };

    const showAttachment = () => {
      emergencyAttachmentOffcanvas.value?.show();
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    return {
      emergency,
      isOrs,
      isProvince,
      isLoading,
      emergencyForm,
      emergencyAttachmentOffcanvas,
      emergencyAttachmentModel,
      emergencyAttachmentForm,
      emergencyImageModal,
      editClick,
      attachmentClick,
      uploadClick,
      uploadClose,
      imageClick,
      showAttachment,
      thaiDate,
    };
  },
});
